import React from 'react';
import axios from "../../../../containers/api";
import { Alert, Button, FormGroup, Input, Label, Card, CardBody, Row } from "reactstrap";
import { showCatchError, toEnglishNumbers } from "../../../../helpers/Utils";
import { Colxx } from "../../../../components/common/CustomBootstrap";

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            TransportationCompany: [],
            ProductOwner: [],
            pass: '',
            errors: [],
            loading: false
        };
    }

    componentDidMount() {
        if (this.props.memberType.role === 'TransportationCompanyAdmin')
            this.GetByTransportationCompanyId();
        else if (this.props.memberType.role === 'ProductOwnerAdmin')
            this.GetByProductOwnerId();
    }

    validateInputData = () => {
        this.props.closeSweetAlert();
        const errors = [];
        if (!this.state.pass || this.state.pass.length < 6) {
            errors.push("رمز عبور باید حداقل ۶ کاراکتر باشد");
        }
        this.setState({ errors });
        if (errors.length === 0) this.changepass();
        else this.props.showAlert("لطفاً خطاها را برطرف کنید", "error");
    };

    changepass = () => {
        this.props.showSpinner();
        const model = { NewPassword: toEnglishNumbers(this.state.pass) };
        axios.put('/api/v1/users/change-password', model)
            .then(() => {
                this.props.hideSpinner();
                this.props.showAlert("رمز عبور با موفقیت تغییر کرد", "success");
                this.setState({ pass: '' });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetByTransportationCompanyId = () => {
        this.props.showSpinner();
        const Id = parseInt(this.props.memberType.clientId);
        axios.get(`/api/v1/transportation-companies/GetByTransportationCompanyId?TransportationCompanyId=${Id}`)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data) this.setState({ TransportationCompany: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetByProductOwnerId = () => {
        this.props.showSpinner();
        const Id = parseInt(this.props.memberType.clientId);
        axios.get(`/api/v1/ProductOwner/GetByProductOwnerId?ProductOwnerId=${Id}`)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data) this.setState({ ProductOwner: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    render() {
        const { TransportationCompany, ProductOwner, pass, errors } = this.state;
        const isCompany = this.props.memberType.role === 'TransportationCompanyAdmin';

        return (
            <div className="profile-container" dir="rtl">
                {/* بخش اطلاعات */}
                <Card className="info-card mb-4 shadow-lg">
                    <CardBody>
                        <h4 className="card-title mb-4">اطلاعات حساب</h4>

                        {isCompany ? (
                            <>
                                <Row className="g-3">
                                    <Colxx md="4"><InfoItem label="نام شرکت" value={TransportationCompany.transportationCompanyName} /></Colxx>
                                    <Colxx md="4"><InfoItem label="کد ملی" value={TransportationCompany.nationalId} /></Colxx>
                                    <Colxx md="4"><InfoItem label="موبایل" value={TransportationCompany.mobile} /></Colxx>
                                </Row>
                                <Row className="g-3 mt-2">
                                    <Colxx md="4"><InfoItem label="شهر" value={TransportationCompany.cityName} /></Colxx>
                                    <Colxx md="8"><InfoItem label="آدرس" value={TransportationCompany.address} /></Colxx>
                                </Row>
                            </>
                        ) : (
                            <Row className="g-3">
                                <Colxx md="4"><InfoItem label="نام کامل" value={`${ProductOwner.firstname} ${ProductOwner.lastname}`} /></Colxx>
                                <Colxx md="4"><InfoItem label="کد ملی" value={ProductOwner.meliCode} /></Colxx>
                                <Colxx md="4"><InfoItem label="موبایل" value={ProductOwner.mobile} /></Colxx>
                            </Row>
                        )}
                    </CardBody>
                </Card>

                {/* بخش تغییر رمز */}
                <Card className="password-card shadow-lg">
                    <CardBody>
                        <h5 className="card-title mb-4">تغییر رمز عبور</h5>
                        <Row className="align-items-end">
                            <Colxx md="8">
                                <FormGroup>
                                    <Label className="fw-bold">رمز جدید (حداقل ۶ کاراکتر)</Label>
                                    <Input
                                        type="password"
                                        value={pass}
                                        onChange={(e) => this.setState({ pass: e.target.value })}
                                        className="form-control-lg"
                                        placeholder="••••••"
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="4">
                                <Button
                                    color="primary"
                                    size="lg"
                                    className="w-100 shadow-sm"
                                    onClick={() => this.props.showSweetAlert(
                                        "آیا از تغییر رمز عبور مطمئن هستید؟",
                                        "",
                                        "warning",
                                        this.validateInputData
                                    )}
                                >
                                    تغییر رمز
                                </Button>
                            </Colxx>
                        </Row>

                        {/* نمایش خطاها */}
                        {errors.length > 0 && (
                            <div className="mt-3">
                                {errors.map((err, i) => (
                                    <Alert color="danger" key={i} className="alert-sm">
                                        {err}
                                    </Alert>
                                ))}
                            </div>
                        )}
                    </CardBody>
                </Card>
            </div>
        );
    }
}

// کامپوننت کوچک برای نمایش اطلاعات
const InfoItem = ({ label, value }) => (
    <div className="info-item">
        <Label className="text-muted small">{label}</Label>
        <p className="mb-0 fw-medium">{value || "-"}</p>
    </div>
);

export default Profile;